import {Collection} from 'vue-mc'
import {IntPromotedCarouselModel} from '@/models/intPromotedCarouselModel'

/**
 * intPromotedCarouselCollection collection
 */

export default class IntPromotedCarouselCollection extends Collection {

	// Default attributes that define the "empty" state.
	defaults() {
		return {
			interpreter_promotion_id: 0,
			interpreter_id: 0,
			first_name: '',
			surname: 0,
			profile: '',
			language: '',
			naati_cpn: ''
		}
	}

    model() {
        return IntPromotedCarouselModel;
    }

    // Route configuration
    routes() {
        return {
	        fetch: "interpreters/promoted"
        }
    }
}



// WEBPACK FOOTER //
// ./src/collections/intPromotedCarouselCollection.js